import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 待审批列表
    approvalList: [],
    // 当前索引
    currentIndex: 0
  },
  getters: {
    getApprovalList: state => state.approvalList,
    getCurrentIndex: state => state.currentIndex
  },
  mutations: {
    setApprovalList (state, list) {
      state.approvalList = [...list]
    },
    addApprovalList (state, list) {
      state.approvalList.push(...list)
    },
    removeOneOfApprovalList (state, index) {
      state.approvalList.splice(index, 1)
    },
    setCurrentIndex (state, index) {
      state.currentIndex = index
    },
    turnCurrentIndex (state, i) {
      state.currentIndex += i
    }
  },
  actions: {
    SET_APPROVAL_LIST ({ commit }, list) {
      commit('setApprovalList', list)
    },
    ADD_APPROVAL_LIST ({ commit }, list) {
      commit('addApprovalList', list)
    },
    SET_CURRENT_INDEX ({ commit }, index) {
      commit('setCurrentIndex', index)
    },
    TURN_CURRENT_INDEX ({ commit }, i) {
      commit('turnCurrentIndex', i)
    },
    REMOVE_ONE_OF_APPROVAL_LIST ({ commit }, index) {
      commit('removeOneOfApprovalList', index)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js